import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CardModel from "../components/CardModel";
import { AIModel } from "../types/AIModel";
import { storage } from "../utils/storage";

interface HomeProps {
  backgroundImage?: string;
  setSelectedCard?: (model: AIModel) => void;
  render?: (handleChatInputFocus: () => void) => React.ReactNode;
}

const HomeContent: React.FC<{
  backgroundImage?: string;
  handleModelSelect: (model: AIModel) => void;
  handleChatInputFocus: () => void;
}> = ({ backgroundImage, handleModelSelect, handleChatInputFocus }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        marginTop: isMobile || isTablet ? 56 : 24,
      }}>
      <h1>
        Welcome <br /> to MixxAI
      </h1>
      <CardModel onSelectModel={handleModelSelect} />
    </div>
  );
};

const Home: React.FC<HomeProps> = ({
  backgroundImage,
  setSelectedCard,
  render,
}) => {
  const [selectedModel, setSelectedModel] = useState<AIModel | null>(null);
  const navigate = useNavigate();

  const handleModelSelect = (model: AIModel) => {
    setSelectedModel(model);
    if (setSelectedCard) {
      setSelectedCard(model);
    }
    localStorage.setItem("selectedModelId", model.id.toString());
  };

  const handleChatInputFocus = () => {
    const token = storage.getJwtToken();
    if (!token) {
      navigate("/get-started");
      return;
    }

    if (selectedModel) {
      navigate(`/chat/${selectedModel.id}`);
    }
  };

  if (render) {
    const layoutWithChatInput = render(handleChatInputFocus);

    return React.cloneElement(
      layoutWithChatInput as React.ReactElement,
      {},
      <HomeContent
        backgroundImage={backgroundImage}
        handleModelSelect={handleModelSelect}
        handleChatInputFocus={handleChatInputFocus}
      />
    );
  }

  return (
    <HomeContent
      backgroundImage={backgroundImage}
      handleModelSelect={handleModelSelect}
      handleChatInputFocus={handleChatInputFocus}
    />
  );
};

export default Home;
